function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20,0A20,20,0,1,0,40,20,20,20,0,0,0,20,0Zm0,36.67A16.67,16.67,0,1,1,36.67,20,16.68,16.68,0,0,1,20,36.67ZM28.33,20a1.66,1.66,0,0,1-1.66,1.67h-5v5a1.67,1.67,0,0,1-3.34,0v-5h-5a1.67,1.67,0,0,1,0-3.34h5v-5a1.67,1.67,0,0,1,3.34,0v5h5A1.66,1.66,0,0,1,28.33,20Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.4a349d4f.svg";
export { ForwardRef as ReactComponent };